import axios from "axios";
import toast from "react-hot-toast";
const BASE_URL = process.env.REACT_APP_API_BASE_URL;

export const addLead = (payload) => {
  return async (dispatch) => {
    try {
      dispatch({ type: "ADD_LEAD_REQUEST" });

      const config = {
        headers: {
          "Content-Type": "application/json",
        },
      };

      const { data } = await axios.post(
        `${BASE_URL}/leads/add`,
        payload,
        config
      );

      if (data.statusCode === 200) {
        dispatch({ type: "ADD_LEAD_SUCCESS", payload: data });
      } else {
        dispatch({ type: "ADD_LEAD_FAILED", payload: data });
      }
      return data;
    } catch (error) {
      dispatch({
        type: "ADD_LEAD_FAILED",
        payload: error?.response?.data?.message,
      });
      return error?.response?.data;
    } finally {
      dispatch({ type: "STOP_LOADING" });
    }
  };
};

export const listLocalityByCity = (payload) => {
  return async (dispatch) => {
    try {
      dispatch({ type: "LIST_LOCALITY_BY_CITY_REQUEST" });

      const config = {
        headers: {
          "Content-Type": "application/json",
        },
      };

      const { data } = await axios.post(
        `${BASE_URL}/leads/list-by-city`,
        payload,
        config
      );

      if (data.statusCode === 200) {
        dispatch({ type: "LIST_LOCALITY_BY_CITY_SUCCESS", payload: data });
      } else {
        dispatch({ type: "LIST_LOCALITY_BY_CITY_FAILED", payload: data });
      }
    } catch (error) {
      dispatch({
        type: "LIST_LOCALITY_BY_CITY_FAILED",
        payload: error?.response?.data?.message,
      });
      return error?.response?.data;
    } finally {
      dispatch({ type: "STOP_LOADING" });
    }
  };
};

export const viewLeadList = (payload) => {
  return async (dispatch) => {
    try {
      dispatch({ type: "GET_LEAD_LIST_REQUEST" });

      const config = {
        headers: {
          "Content-Type": "application/json",
        },
      };

      const { data } = await axios.post(
        `${BASE_URL}/leads/list`,
        payload,
        config
      );

      if (data.statusCode === 200) {
        dispatch({ type: "GET_LEAD_LIST_SUCCESS", payload: data });
      } else {
        dispatch({ type: "GET_LEAD_LIST_FAILED", payload: data });
      }
      return data;
    } catch (error) {
      dispatch({
        type: "GET_LEAD_LIST_FAILED",
        payload: error?.response?.data?.message,
      });
    } finally {
      dispatch({ type: "STOP_LOADING" });
    }
  };
};

export const viewLeadById = (id) => {
  return async (dispatch) => {
    // dispatch({ type: "START_LOADING" });
    try {
      dispatch({ type: "GET_LEAD_REQUEST" });

      const config = {
        headers: {
          "Content-Type": "application/json",
        },
      };

      const { data } = await axios.get(
        `${BASE_URL}/leads/${id}`,
        config
      );

      if (data.statusCode === 200) {
        dispatch({ type: "GET_LEAD_SUCCESS", payload: data });
        return data;
      } else {
        dispatch({ type: "GET_LEAD_FAILED", payload: data });
      }
    } catch (error) {
      dispatch({
        type: "GET_LEAD_FAILED",
        payload: error?.response?.data?.message,
      });
    } finally {
      dispatch({ type: "STOP_LOADING" });
    }
  };
};

export const changeLeadStatus = (payload) => {
  return async (dispatch) => {
    dispatch({ type: "START_LOADING" });
    try {
      dispatch({ type: "CHANGE_LEAD_STATUS_REQUEST" });

      const config = {
        headers: {
          "Content-Type": "application/json",
        },
      };

      const { data } = await axios.post(
        `${BASE_URL}/leads/change-status`,
        payload,
        config
      );

      if (data.statusCode === 200) {
        toast.success(data.message || "Status updated successfully!");
        dispatch({ type: "CHANGE_LEAD_STATUS_SUCCESS", payload: data });
        return data;
      } else {
        toast.error(data.message || "Failed to update status");
        dispatch({ type: "CHANGE_LEAD_STATUS_FAILED", payload: data });
        return data;
      }
    } catch (error) {
      toast.error(error?.response?.data?.message || "Something went wrong!");
      dispatch({
        type: "CHANGE_LEAD_STATUS_FAILED",
        payload: error?.response?.data?.message,
      });
    } finally {
      dispatch({ type: "STOP_LOADING" });
    }
  };
};

export const listAddress = (payload) => {
  return async (dispatch) => {
    // dispatch({ type: "START_LOADING" });
    try {
      dispatch({ type: "LIST_ADDRESS_REQUEST" });

      const config = {
        headers: {
          "Content-Type": "application/json",
        },
      };

      const { data } = await axios.post(
        `${BASE_URL}/leads/list-address`,
        payload,
        config
      );

      if (data.statusCode === 200) {
        dispatch({ type: "LIST_ADDRESS_SUCCESS", payload: data });
        return data;
      } else {
        dispatch({ type: "LIST_ADDRESS_FAILED", payload: data });
      }
    } catch (error) {
      dispatch({
        type: "LIST_ADDRESS_FAILED",
        payload: error?.response?.data?.message,
      });
    } finally {
      dispatch({ type: "STOP_LOADING" });
    }
  };
};

export const addAddress = (payload) => {
  return async (dispatch) => {
    // dispatch({ type: "START_LOADING" });
    try {
      dispatch({ type: "ADD_ADDRESS_REQUEST" });

      const config = {
        headers: {
          "Content-Type": "application/json",
        },
      };

      const { data } = await axios.post(
        `${BASE_URL}/leads/add-address`,
        payload,
        config
      );

      if (data.statusCode === 200) {
        toast.success(data.message || "Address added successfully!");
        dispatch({ type: "ADD_ADDRESS_SUCCESS", payload: data });
        return data;
      } else {
        toast.error(data.message || "Failed to add address");
        dispatch({ type: "ADD_ADDRESS_FAILED", payload: data });
        return data;
      }
    } catch (error) {
      toast.error(error?.response?.data?.message || "Something went wrong!");
      dispatch({
        type: "ADD_ADDRESS_FAILED",
        payload: error?.response?.data?.message,
      });
    } finally {
      dispatch({ type: "STOP_LOADING" });
    }
  };
};

export const removeAddress = (payload) => {
  return async (dispatch) => {
    // dispatch({ type: "START_LOADING" });
    try {
      dispatch({ type: "REMOVE_ADDRESS_REQUEST" });

      const config = {
        headers: {
          "Content-Type": "application/json",
        },
      };

      const { data } = await axios.post(
        `${BASE_URL}/leads/remove-address`,
        payload,
        config
      );

      if (data.statusCode === 200) {
        toast.success(data.message || "Address removed successfully!");
        dispatch({ type: "REMOVE_ADDRESS_SUCCESS", payload: data });
        return data;
      } else {
        toast.error(data.message || "Failed to remove address");
        dispatch({ type: "REMOVE_ADDRESS_FAILED", payload: data });
        return data;
      }
    } catch (error) {
      toast.error(error?.response?.data?.message || "Something went wrong!");
      dispatch({
        type: "REMOVE_ADDRESS_FAILED",
        payload: error?.response?.data?.message,
      });
    } finally {
      dispatch({ type: "STOP_LOADING" });
    }
  };
};

export const createAppointment = (payload) => {
  return async (dispatch) => {
    // dispatch({ type: "START_LOADING" });
    try {
      dispatch({ type: "CREATE_APPOINTMENT_REQUEST" });

      const config = {
        headers: {
          "Content-Type": "application/json",
        },
      };

      const { data } = await axios.post(
        `${BASE_URL}/leads/appointment/create`,
        payload,
        config
      );

      if (data.statusCode === 200) {
        toast.success(data.message || "Appointment created successfully!");
        dispatch({ type: "CREATE_APPOINTMENT_SUCCESS", payload: data });
        return data;
      } else {
        toast.error(data.message || "Failed to create appointment");
        dispatch({ type: "CREATE_APPOINTMENT_FAILED", payload: data });
        return data;
      }
    } catch (error) {
      toast.error(error?.response?.data?.message || "Something went wrong!");
      dispatch({
        type: "CREATE_APPOINTMENT_FAILED",
        payload: error?.response?.data?.message,
      });
    } finally {
      dispatch({ type: "STOP_LOADING" });
    }
  };
};

export const listFranchiseByCity = (payload) => {
  return async (dispatch) => {
    try {
      dispatch({ type: "LIST_FRANCHISE_BY_CITY_REQUEST" });

      const config = {
        headers: {
          "Content-Type": "application/json",
        },
      };

      const { data } = await axios.post(
        `${BASE_URL}/leads/franchise/list`,
        payload,
        config
      );

      if (data.statusCode === 200) {
        dispatch({ type: "LIST_FRANCHISE_BY_CITY_SUCCESS", payload: data });
      } else {
        dispatch({ type: "LIST_FRANCHISE_BY_CITY_FAILED", payload: data });
      }
      return data;
    } catch (error) {
      dispatch({
        type: "LIST_FRANCHISE_BY_CITY_FAILED",
        payload: error?.response?.data?.message,
      });
    } finally {
      dispatch({ type: "STOP_LOADING" });
    }
  };
};

export const assignFranchise = (payload) => {
  return async (dispatch) => {
    try {
      dispatch({ type: "ASSIGN_FRANCHISE_REQUEST" });

      const config = {
        headers: {
          "Content-Type": "application/json",
        },
      };

      const { data } = await axios.post(
        `${BASE_URL}/leads/assign-franchise`,
        payload,
        config
      );

      if (data.statusCode === 200) {
        toast.success(data.message || "Franchise assigned successfully!");
        dispatch({ type: "ASSIGN_FRANCHISE_SUCCESS", payload: data });
        return data;
      } else {
        toast.error(data.message || "Failed to assign franchise");
        dispatch({ type: "ASSIGN_FRANCHISE_FAILED", payload: data });
        return data;
      }
    } catch (error) {
      toast.error(error?.response?.data?.message || "Something went wrong!");
      dispatch({
        type: "ASSIGN_FRANCHISE_FAILED",
        payload: error?.response?.data?.message,
      });
    } finally {
      dispatch({ type: "STOP_LOADING" });
    }
  };
};

export const updateLead = (payload) => {
  return async (dispatch) => {
    dispatch({ type: "START_LOADING" });
    try {
      dispatch({ type: "UPDATE_LEAD_REQUEST" });

      const config = {
        headers: {
          "Content-Type": "application/json",
        },
      };

      const { data } = await axios.post(
        `${BASE_URL}/leads/update`,
        payload,
        config
      );

      if (data.statusCode === 200) {
        toast.success(data.message || "Lead updated successfully!");
        dispatch({ type: "UPDATE_LEAD_SUCCESS", payload: data });
        return data;
      } else {
        toast.error(data.message || "Failed to update lead");
        dispatch({ type: "UPDATE_LEAD_FAILED", payload: data });
        return data;
      }
    } catch (error) {
      toast.error(error?.response?.data?.message || "Something went wrong!");
      dispatch({
        type: "UPDATE_LEAD_FAILED",
        payload: error?.response?.data?.message,
      });
      return error?.response?.data;
    } finally {
      dispatch({ type: "STOP_LOADING" });
    }
  };
};